import { updateOfferLetterStatus } from 'modules/offerLetter/store/actions';
import { combineReducers } from 'redux';
import { isLoadingReducer } from 'store/reducerUtils';

const isLoading = isLoadingReducer(updateOfferLetterStatus);

export const rejectOfferLetter = combineReducers({
    isLoading,
});
